<template>
  <SAISelect
    :value="computedValue"
    v-on="$listeners"
    v-bind="$attrs"
    emit-value
    :options="filteredOptions"
    @filter="filterFn"
    placeholder="Select Reason"
  />
</template>

<script>
import { SAISelect } from 'ecx.saigon.ui.common';

export default {
  name: 'HRApprovalReasonSelect',
  props: {
    value: {
      type: undefined
    }
  },
  data() {
    return {
      filteredOptions: []
    };
  },
  computed: {
    options() {
      return Object.values(this.$Constants.HR_APPROVAL_REASONS);
    },
    computedValue() {
      if (!this.value) {
        return undefined;
      }
      return typeof this.value === 'string'
        ? this.$Constants.HR_APPROVAL_REASONS[this.value]
        : this.value;
    }
  },
  methods: {
    filterFn(value, update) {
      update(() => {
        this.filteredOptions = this.options.filter((state) => {
          return (
            state.label.toLocaleLowerCase().indexOf(value.toLowerCase()) > -1
          );
        });
      });
    }
  },
  components: {
    SAISelect
  }
};
</script>
